module.exports = __webpack_public_path__ + "img/text_impacto_social.1b7c11dc.png";